import { gql } from "graphql-tag"

const newsSource = gql`
  input NewsSourceAddInput {
    isOverridesOnly: Boolean
    labelId: ID
    outletId: ID
    overrides: NewsSourceOverridesInput
    releaseDate: String
    serviceName: String
    url: String!
  }

  type NewsSource {
    id: ID!
    image: String
    isFlagged: Boolean!
    labelId: ID
    name: String
    outletId: ID
    releaseDate: String
    serviceName: String
    text: String
    url: String!
  }

  input NewsSourceOverridesInput {
    image: String
    name: String
    releaseDate: String
    text: String
  }

  input NewsSourceUpdateInput {
    id: ID!
    isFlagged: Boolean
    name: String
    overrides: NewsSourceOverridesInput
    text: String
    url: String
  }

  type NewsSourceResponse {
    id: ID!
    labelId: ID
    outletId: ID
    releaseDate: String
    serviceName: String
  }

  input PreviewNewsSourceAddInput {
    overrides: NewsSourceOverridesInput
    serviceName: String!
    url: String!
  }

  type PreviewNewsSource {
    errorFields: [String]
    image: String
    isValid: Boolean!
    name: String
    releaseDate: String
    text: String
    url: String!
  }

  type EightLeggedFreakNewsSource {
    id: ID!
    isFlagged: Boolean!
    isNew: Boolean!
    name: String!
    url: String!
  }

  input EightLeggedFreakGatherNewsSourcesInput {
    isAllAroundGather: Boolean
    serviceName: String!
  }

  input EightLeggedFreakNewsSourcesListInput {
    cursor: String
    serviceName: String!
  }

  input EightLeggedFreakNewsSourceUpdateInput {
    id: ID!
    isFlagged: Boolean
    name: String
    url: String
  }

  type EightLeggedFreakGatherNewsSources {
    status: String!
  }

  type EightLeggedFreakNewsSourcesListResponse {
    links: [EightLeggedFreakNewsSource]
    nextCursor: String
  }

  type EightLeggedFreakNewsSourceResponse {
    id: ID!
  }
`

export default newsSource
